module.exports = __webpack_public_path__ + "static/media/google.6645f21d.svg";